<router-outlet></router-outlet>
<ng-container *ngIf="activatedRoute.children.length === 0">
  <app-state [state]="state">
    <ng-container *ngIf="!state.loading && !state.error">
      <div class="row">
        <div class="col-md-6">
          <div class="card">
            <div class="content">
              <ng-container *ngIf="createdCompanyDirectory; else templateCreatingNewDirectory;">
                <app-header [title]="createdCompanyDirectory.name + ' has been created'" [description]="'Your IT Administrator will be able to use the base URL and bearer token below to set up the integration in your identity provider. Again, please note that for security purposes this will be the only time you will be able to take a note of the token.'" [helpLink]="'https://help.frankli.io/en/articles/5429197-how-do-i-set-up-user-provisioning-and-de-provisioning-with-azure-active-directory'"></app-header>

                <div class="row">
                  <div class="col-md-6 col-md-offset-3">
                    <div class="frankli-form-group frankli-form-group-filled">
                      <label for="baseUrl">
                        <span>Base URL</span>
                        <span class="clickable m-left-5 fal"
                          [ngClass]="baseUrlCopied ? 'fa-check' : 'fa-copy'"
                          [copy-clipboard]="baseUrl"
                          (copied)="baseUrlCopied = true"
                          (mouseout)="timeoutCheckmarkIcon(eClipboardField.BASE_URL)"
                          [tooltip]="baseUrlCopied ? 'Base URL Copied to Clipboard' : 'Copy Base URL to Clipboard'">
                        </span>
                      </label>
                      <input id="baseUrl" disabled class="form-control" type="text" [value]="baseUrl">
                    </div>
                    <br>
                    <div class="frankli-form-group frankli-form-group-filled">
                        <label for="bearerToken">
                            <span>Bearer Token</span>
                            <span class="clickable m-left-5 fal"
                              [ngClass]="bearerTokenCopied ? 'fa-check' : 'fa-copy'"
                              [copy-clipboard]="createdCompanyDirectory.secretToken"
                              (copied)="bearerTokenCopied = true"
                              (mouseout)="timeoutCheckmarkIcon(eClipboardField.BEARER_TOKEN)"
                              [tooltip]="bearerTokenCopied ? 'Bearer Token Copied to Clipboard' : 'Copy Bearer Token to Clipboard'">
                            </span>
                        </label>
                        <input id="bearerToken" disabled class="form-control" type="text" [value]="createdCompanyDirectory.secretToken">
                    </div>
                  </div>
                </div>

                <hr class="row">

                <div class="text-center">
                  <app-button (onClick)="navigateBack()">Finish</app-button>
                </div>
              </ng-container>

              <ng-template #templateCreatingNewDirectory>
                <app-header [title]="'Setup a new Directory'" [description]="'After providing a name for your directory, you will be given a token to authenticate the integration with your identity provider. Please note that for security purposes this will be the only time you will be able to take a note of the token.'" [helpLink]="'https://help.frankli.io/en/articles/5429197-how-do-i-set-up-user-provisioning-and-de-provisioning-with-azure-active-directory'"></app-header>

                <div class="row">
                  <div class="col-md-6 col-md-offset-3">
                    <div class="frankli-form-group" [class.frankli-form-group-invalid]="state.submitted && controlName.invalid" [class.frankli-form-group-filled]="controlName.value.length > 0">
                      <label for="directoryName">Directory name</label>
                      <input type="text" id="directoryName" class="form-control" [formControl]="controlName"/>
                      <div class="frankli-form-group-alert">
                        <ng-container *ngIf="state.submitted && controlName.invalid">
                          <div *ngIf="controlName.hasError('required')">Required</div>
                          <div *ngIf="(controlName.hasError('maxlength') || controlName.hasError('minLength'))">Must be between 1 and 255 characters</div>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </div>

                <hr class="row">

                <div class="text-center">
                  <app-button (onClick)="submitForm()">Create directory</app-button>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </app-state>
</ng-container>
